
export function createNavigationGlobalIcon(
  color: string,
  style: 'filled' | 'dotted' | 'dashed' = 'filled',
  glow: boolean = false,
  filled: boolean = false
): HTMLCanvasElement {

  const canvas = document.createElement('canvas');
  const size = 28;
  canvas.width = size;
  canvas.height = size;

  const ctx = canvas.getContext('2d');
  if (!ctx) return canvas;

  ctx.translate(size / 2, size / 2);
  ctx.rotate(-90 * Math.PI / 180);
  ctx.translate(-size / 2, -size / 2);

  ctx.font = '26px "Material Icons"';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  if (style === 'dotted') ctx.setLineDash([2, 3]);
  else if (style === 'dashed') ctx.setLineDash([5, 4]);
  else ctx.setLineDash([]);

  if (glow) {
    ctx.shadowColor = '#ffffff';
    ctx.shadowBlur = 30;
  }

  ctx.strokeStyle = color;
  ctx.lineWidth = 2;
  const iconChar = '\ue55d';

if (filled) {
  ctx.fillStyle = color;
  ctx.fillText(iconChar, size / 2, size / 2);
}

ctx.strokeText(iconChar, size / 2, size / 2);

  ctx.shadowBlur = 0;

  return canvas;
}
